import { asPage } from 'src/components/hoc/asPage'
import { Contributions } from 'src/compositions/Contributions'

export default asPage(Contributions, { pageTitle: '掲示板TOP' })
